
import * as api from '@/config/api';

export default {
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    downloadUrl: {
      get: function get() {
        return api.resStoreDownloadUrl;
      }
    }
  }
};